/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import State from './State';

/**
 * Elemento dello Stepper.
 */
const Step = (props) => (
  <div>{JSON.stringify(props)}</div>
);

Step.State = State;

Step.propTypes = {
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Elemento da mostrare al posto dei children */
  code: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Icona da impostare per lo step */
  icon: PropTypes.node,
  /**
   * Callback invocata al click dello step:
   * ```
   *  onClick(index)
   * ```
   * dove:
   * * *index*: indice dello step selezionato
   */
  onClick: PropTypes.func,
  /** Indica se lo step è opzionale */
  optional: PropTypes.bool,
  /** Indica lo stato dello Step, può assumere
     * i seguenti valori: ACTIVE: 0, DONE: 1, TODO: 2, ERROR: 3 */
  state: PropTypes.number.isRequired,
  /** Il titolo dello step */
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  /** sottotitolo opzionale */
  subTitle: PropTypes.string,
};

Step.defaultProps = {
  className: '',
  code: null,
  icon: null,
  onClick: null,
  optional: false,
  subTitle: null,
};

export default Step;
